<template>
  <div class="app-container">
    <div class="fixedButton">
      <vxe-button class="examineButton" status="success" @click="savaBicType">保存</vxe-button>
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars" :style="`height:${$store.state.app.height - 70}px;`">
      <div class="main-div">
        <el-form ref="bicTypeForm" class="UniformCss" :inline="true" :model="FormData" label-width="110px" :rules="rules">
          <div class="formLine">值列表信息</div>
          <div class="budgetBox">
            <el-row :gutter="5" style="margin-top:20px">
              <el-col :span="12">
                <el-form-item prop="code" label="类型编码" :rules="{ required: true, trigger: 'blur' }">
                  <el-input v-model="FormData.code" :disabled="isDisabled" style="width:200px"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="name" :rules="{ required: true, trigger: 'blur' }">
                  <label slot="label"><span class="el-item-label">类型名称</span></label>
                  <el-input v-model="FormData.name"  style="width:200px" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="orderNo" :rules="{ required: true, trigger: 'blur' }">
                  <label slot="label"><span class="el-item-label">顺序号</span></label>
                  <a-input-number v-model="FormData.orderNo" controls-position="right" :min="0" :max="10000"  style="width:200px"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="status" :rules="{ required: true, trigger: 'blur' }">
                  <label slot="label"><span class="el-item-label">状态</span></label>
                  <el-select v-model="FormData.status" placeholder="请选择"  style="width:200px">
                    <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item prop="remark">
                  <label slot="label"><span class="el-item-label">备注</span></label>
                  <el-input v-model="FormData.remark" type="textarea" :rows="3"  style="width:200px" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
            <br>
          </div>
          <div class="formLine">值列表取值</div>
          <div style="margin: 5px 0 5px 0px">
            <vxe-button status="primary" icon="el-icon-plus" @click="insertEvent()">新建</vxe-button>
            <!-- <vxe-button type="success" icon="el-icon-check" @click="saveObC">保存</vxe-button> -->
            <vxe-button status="danger" icon="el-icon-delete" @click="deleteValue()">删除</vxe-button>
          </div>
          <div class="budgetBox">
            <el-form ref="OBform" label-width="1px" :model="modelTableBaseB">
              <vxe-table
                ref="xTable"
                border
                show-header-overflow
                show-overflow
                class="mytable-scrollbar"
                :column-config="{ resizable: true }"
                stripe
                round
                :loading="listLoading"
                :align="allAlign"
                :edit-config="{trigger: 'manual', mode: 'row'}"
                :scroll-y="{ enabled: false }"
                :edit-rules="validRules"
                :row-config="{ isHover: true }"
                :data="currentTableData"
              >
                <vxe-column type="checkbox" width="60" />
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column :visible="false" field="id" title="id" align="center" />
                <vxe-column field="value" title="取值" align="center" :edit-render="{}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.value" type="text" placeholder="请输入值编码" />
                  </template>
                </vxe-column>
                <vxe-column field="name" title="名称" align="center" :edit-render="{}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.name" type="text" placeholder="请输入值名称" />
                  </template>
                </vxe-column>
                <vxe-column field="orderNo" title="顺序号" align="center" :edit-render="{}">
                  <template #edit="{ row }">
                    <a-input-number v-model="row.orderNo" controls-position="right" :min="0" :max="10000" />
                  </template>
                </vxe-column>
                <vxe-column field="status" title="状态" align="center" :edit-render="{}">
                  <template #default="{ row }">
                    <span v-if="row.status === '1'">有效</span>
                    <span v-else>无效</span>
                  </template>
                  <template #edit="{ row }">
                    <vxe-select v-model="row.status" transfer>
                      <vxe-option v-for="item in statusOptions" :key="item.value" :value="item.value" :label="item.label" />
                    </vxe-select>
                  </template>
                </vxe-column>
                <vxe-column field="remark" title="备注" align="center" :edit-render="{}">
                  <template #edit="{ row }">
                    <vxe-input v-model="row.remark" type="text" placeholder="请输入备注" />
                  </template>
                </vxe-column>
                <vxe-column title="操作" width="160">
                  <template #default="{ row }">
                    <template v-if="$refs.xTable.isActiveByRow(row)">
                      <vxe-button status="success" @click="savaBicValType(row)">保存</vxe-button>
                      <vxe-button @click="cancelRowEvent(row)">取消</vxe-button>
                    </template>
                    <template v-else>
                      <vxe-button status="primary" @click="editRowEvent(row)">编辑</vxe-button>
                    </template>
                  </template>
                </vxe-column>
              </vxe-table>
              <vxe-pager :loading="listLoading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange" />
            </el-form>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getBicInfo, savaBicValTypeInfo, savaBicTypeInfo } from '@/api/bicVal'
// import SiftTpiCredit from '@/views/financiaManagement/tripartiteFinancing/tpiIssueComponents/siftTpiCredit.vue'
const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

const defaultStatusOptions = [
  { value: '1',
    label: '有效'
  },
  {
    value: '0',
    label: '无效'
  }
]
const defaultFormData = {
  id: '',
  name: '',
  code: '',
  orderNo: 0,
  remark: '',
  status: '1',
  domain: 'center'
}

export default {
  name: 'ValueDetail',
  // inject: ['reload'],
  components: {
    // SiftTpiCredit
  },
  data() {
    const valueValid = ({ cellValue }) => {
      if (cellValue && !/^\w+$/.test(cellValue)) {
        return new Error('值编码格式不正确，必须字母或数字')
      }
    }
    return {
      credit: {},
      FormData: Object.assign({}, defaultFormData),
      listLoading: false,
      statusOptions: Object.assign({}, defaultStatusOptions),
      base: {},
      tableData: [],
      tableDataTemp: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      validRules: {
        value: [
          { validator: valueValid }
        ],
        name: [
          { required: true, message: '值名称必须填写' }
        ],
        orderNo: [
          { type: 'number', min: 0, max: 100000, message: '输入 0 ~ 100000 范围' }
        ]
      },
      currentTableData: [],
      allAlign: 'center',
      labelPosition: 'left',
      modelTableBase: {
        data: [{}],
        selection: []
      },
      modelTableBaseB: {
        data: [{}],
        selection: []
      },
      isSaveOB: false,
      isSaveOBC: false,
      showComp: false,
      pagination: Object.assign({}, defaultPagination),
      isDisabled: false
    }
  },

  watch: {},
  created() {
    this.FormData.domain = this.$route.params.domain
    if (this.$route.params.id !== 'null') {
      this.FormData.id = this.$route.params.id
      this.getBicInfo()
      this.isDisabled = true
    }
  },
  methods: {
    handlePreview() {
      this.fileList = this.$refs.uploadFile.uploadFiles
      // console.log(this.fileList);
    },
    ReturnFun() {
      // this.$router.push({
      //   name: 'ValueListManagement'
      // })
      this.$closePage('/comm/bicValDetail', '/comm/bicvalList')
    },
    savaBicType() {
      this.$refs['bicTypeForm'].validate((valid) => {
        if (valid) {
          const params = {
            'typelistid': this.FormData.id,
            'typecode': this.FormData.code,
            'typename': this.FormData.name,
            'orderno': this.FormData.orderNo,
            'remark': this.FormData.remark,
            'status': this.FormData.status,
            'domain': this.$route.params.domain
          }
          savaBicTypeInfo(params).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.ReturnFun()
            } else {
              this.$message.error('保存失败！ ' + res.message)
            }
          })
        } else {
          this.$message.warning('必填项不能为空')
          return
        }
      })
    },
    async savaBicValType(row) {
      if (this.FormData.id === '') {
        this.$message.error('请先保存值列表信息')
        return
      }
      const errMap = await this.$refs.xTable.validate(true).catch(errMap => errMap)
      if (errMap) {
        this.$message.error('校验不通过')
        return
      }
      const params = {
        'vallistid': row.id,
        'typelistid': this.FormData.id,
        'typecode': row.code,
        'valcode': row.value,
        'valname': row.name,
        'orderno': row.orderNo,
        'remark': row.remark,
        'status': row.status,
        'domain': this.$route.params.domain
      }
      console.log(params)
      savaBicValTypeInfo(params).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          // this.reload()
        } else {
          this.$message.error('保存失败')
        }
      })
    },
    getBicInfo() {
      const param = {
        'id': this.FormData.id,
        'domain': this.FormData.domain
      }
      getBicInfo(param).then(res => {
        if (res.code === 1) {
          this.FormData = res.data.bicType
          this.tableData = res.data.bicVal
          this.tableDataTemp = res.data.bicVal
          this.handleCurrentData()
        }
      })
    },
    async insertEvent(row) {
      const $table = this.$refs.xTable
      const record = {
        name: '',
        value: '',
        orderNo: '1',
        status: '1',
        remark: ''
      }
      const { row: newRow } = await $table.insertAt(record, row)
      await $table.setActiveCell(newRow, 'name')
    },
    handleCurrentData() {
      this.tablePage.totalResult = this.tableData.length
      this.currentTableData = this.tableData.slice((this.tablePage.currentPage - 1) * this.tablePage.pageSize, this.tablePage.currentPage * this.tablePage.pageSize)
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.handleCurrentData()
    },
    editRowEvent(row) {
      const $table = this.$refs.xTable
      $table.setActiveRow(row)
    },
    saveRowEvent(row) {
      console.log(row)
      const $table = this.$refs.xTable
      $table.clearActived().then(() => {
        this.listLoading = true
        setTimeout(() => {
          this.listLoading = false
          this.$message.success('保存成功')
        }, 300)
      })
    },
    cancelRowEvent(row) {
      const $table = this.$refs.xTable
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row)
      })
    },
    selectionChange(val) {
      this.modelTableBase.selection = val
    },
    addObItem() {
      this.modelTableBase.data.push({})
      this.isSaveOB = !this.isSaveOB
    },
    deleteOBItem(index) {
      this.modelTableBase.data.splice(index, 1)
    },
    saveOb() {
      this.isSaveOB = !this.isSaveOB
    },
    addObItemC() {
      this.modelTableBaseB.data.push({})
      this.isSaveOBC = !this.isSaveOBC
    },
    deleteOBItemC(index) {
      this.modelTableBaseB.data.splice(index, 1)
    },
    saveObC() {
      this.isSaveOBC = !this.isSaveOBC
    },
    showCompDiv() {
      this.showComp = true
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      this.pagination.size = pageSize
      // this.queryByPage();
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-item-label {
  line-height: 20px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
}
.formLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #4489ce;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.obform-item {
  margin: 0 0 16px 0;
  width: 90%;
  white-space: nowrap;
}
.fixedButton {
  padding: 0px 5px 5px;
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  padding: 0 5px;
}
/deep/ .el-form-item {
  display: flex;
}
/deep/ .el-input__inner {
  height: 30px;
}

</style>
